import { QueryKey } from '@tanstack/react-query';
import { getFetchQuery, useFetchQuery } from '@opengov/bnp-core';
import { ISessionV3 } from '@opengov/app-core/types';

const SESSION_V3_URL = '/api/v3/session';
const QUERY_KEY = ['sessionV3'] as const satisfies QueryKey;

export function getSessionV3QueryOptions(getAccessToken?: () => Promise<string>) {
  return getFetchQuery<ISessionV3>({
    queryKey: QUERY_KEY,
    url: SESSION_V3_URL,
    getAccessToken,
    options: { staleTime: 0 }
  });
}

export function useGetSessionV3() {
  return useFetchQuery<ISessionV3>({
    queryKey: QUERY_KEY,
    url: SESSION_V3_URL,
    options: { staleTime: 0 }
  });
}
